import React, { memo } from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { performanceUtil } from '@qnpm/q-design-utils';
import { PADDING_HORIZONTAL, DAY_ITEM_SPACE } from '../style';
const ToolTips = (props) => {
    const { visible, style, content, onLayout, arrowPosition, arrowOffset, computedStyle } = props;
    let { refreshWidth } = props;
    refreshWidth = refreshWidth ? refreshWidth : Dimensions.get('window').width;
    const arrowStyle = getArrowPositionStyle(arrowPosition, computedStyle, refreshWidth);
    const isShow = content && visible;
    if (!isShow) {
        return null;
    }
    return (<View pointerEvents="none" style={[styles.wrapper, computedStyle.toolTip.wrapper, style]} onLayout={onLayout}>
            <Text style={[styles.text, computedStyle.toolTip.text]}>
                {content}
            </Text>
            <View style={[
        styles.arrow,
        computedStyle.toolTip.arrow,
        arrowStyle,
        arrowOffset
    ]}/>
        </View>);
};
function getArrowPositionStyle(position, computedStyle, refreshWidth) {
    if (position === 'left') {
        return Object.assign(Object.assign({}, computedStyle.toolTip.leftArrow), { width: (refreshWidth - PADDING_HORIZONTAL * 2 - DAY_ITEM_SPACE * 6) /
                7 /
                2 });
    }
    if (position === 'right') {
        return Object.assign(Object.assign({}, computedStyle.toolTip.rightArrow), { width: (refreshWidth - PADDING_HORIZONTAL * 2 - DAY_ITEM_SPACE * 6) /
                7 /
                2 });
    }
    return {
        left: '50%',
        marginLeft: computedStyle.toolTip.centerArrow.marginLeft
    };
}
export default memo(ToolTips, performanceUtil.fastDeepEqual);
const styles = StyleSheet.create({
    wrapper: {
        position: 'absolute',
        backgroundColor: 'rgba(0,0,0,.7)',
        zIndex: 3
    },
    text: {
        color: '#FFFFFF'
    },
    arrow: {
        position: 'absolute',
        width: 0,
        height: 0,
        borderTopColor: 'rgba(0,0,0,.7)',
        borderRightColor: 'transparent',
        borderLeftColor: 'transparent',
        borderBottomColor: 'transparent'
    }
});
